<template>
  <div id="app">
    <router-view />
    <browser-compatibility-warning />
    <dev-environments-guard />
    <no-org-guard />
  </div>
</template>

<script>
import BrowserCompatibilityWarning from './components/common/BrowserCompatibilityWarning';
import DevEnvironmentsGuard from './components/common/DevEnvironmentsGuard';
import NoOrgGuard from './components/common/NoOrgGuard';

export default {
  name: 'app',
  components: {
    BrowserCompatibilityWarning,
    DevEnvironmentsGuard,
    NoOrgGuard,
  },
};
</script>

<style>
html,
body {
  margin: 0;
  font-family: "Roboto", sans-serif;
}

html,
body,
#app {
  height: 100%;
}

#app {
  position: relative;
}

.logo {
  float: right;
}

[class^="el-icon-ma"],
[class*=" el-icon-ma"] {
  font-family: "Material Icons" !important;
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: "liga";
}

.el-dialog__wrapper {
  will-change: transform;
}

* {
  box-sizing: border-box;
}

.md-button {
  text-transform: none;
}

.md-icon-button .md-ripple, .md-icon-button:before {
  border-radius: 0% !important;
}
</style>
